import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


// 查询小程序用户信息

export function getProgramUserInfo(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/user/memPage`,
        method: 'post',
        data: data
    })
}